import styled from "styled-components";

const StyledDeploymentFilter = styled.div`
  width: 100%;
`;

export default StyledDeploymentFilter;
